(function () {
  'use strict';

  angular.module('app').service('PackageModalService', PackageModalService);

  PackageModalService.$inject = ['ModalService'];

  function PackageModalService(ModalService) {
    var service = {
      openPackageListModal: openPackageListModal,
    };

    return service;

    ////////////////

    // --------------------------- openPackageListModal -------------------------

    function openPackageListModal(websiteId) {
      ModalService.showModal({
        templateUrl: './app/ajs/packages/modals/package-list-modal.html',
        controller: PackageListsModalCtrl,
        controllerAs: 'vm',
        inputs: {
          websiteId: websiteId,
        },
      }).then(function (modal) {
        modal.element.modal();
      });

      PackageListsModalCtrl.$inject = [
        '$element',
        'UtilService',
        'AbilityService',
        '$location',
        'PackageService',
        'websiteId',
      ];
    }

    function PackageListsModalCtrl(
      $element,
      UtilService,
      AbilityService,
      $location,
      PackageService,
      websiteId
    ) {
      var vm = this;

      vm.UtilService = new UtilService(vm);

      vm.permissions = {
        canShow: AbilityService.can('show_package_accountadmin'),
        canCreate: AbilityService.can('create_package_accountadmin'),
        canUpdate: AbilityService.can('update_package_accountadmin'),
        canDestroy: AbilityService.can('destroy_package_accountadmin'),
      };

      vm.modalTitle = 'PACKAGES';

      // Methods
      vm.showPackage = showPackage;
      vm.addContent = addContent;

      // Initializers
      getPackages();

      function getPackages() {
        vm.loadingItems = true;
        var params = {
          get: 'active',
          only: 'basic',
          usage: true,
          website_id: websiteId,
        };

        PackageService.getPackages(params).then(function (data) {
          vm.packages = data.items;
          vm.loadingItems = false;
        });
      }

      function showPackage(pack) {
        if (!vm.permissions.canShow) {
          return;
        }

        $element.modal('hide'); // bootstrap fade

        setTimeout(function () {
          // Delay x sec
          $location.path(`/packages/${pack.id}`);
        }, 200);
      }

      function addContent(pack) {
        if (!vm.permissions.canCreate) {
          return;
        }

        $element.modal('hide'); // bootstrap fade

        setTimeout(function () {
          // Delay x sec
          $location.path(`/package_contents/new`).search({ WSID: websiteId, packageId: pack.id });
        }, 200);
      }
    }
  }
})();
